import React from "react";
import { Route, Switch } from "react-router-dom";

// UnAuthenticated Routes
import UnAuthenticatedRoute from "./components/UnAuthenticatedRoute";
import Confirm from "./containers/Onboard/Confirm";
import Signup from "./containers/Onboard/Signup";
import FederatedSignin from "./containers/Onboard/FederatedSignin";
import SSO from "./containers/Onboard/SSO";
import ByePage from "./containers/Bye";
import ConfirmVerification from "./containers/Onboard/ConfirmVerification";
import Forgot from "./containers/Onboard/Forgot";
import PasswordReset from "./containers/Onboard/PasswordReset";

// Authenticated Routes
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import Onboard from "./containers/Onboard/Onboard";
import OnboardSurvey from './containers/Onboard/Survey';
import OnboardInfoGraphics from './containers/Onboard/InfoGraphics';
import OnboardChecklist from './containers/Onboard/Checklist';
import NotFound from "./containers/NotFound";
import RemovedSite from "./containers/SiteRemoved";
import Dashboard from "./containers/Dashboard";
import Settings from "./containers/Settings";
import Uploader from "./containers/Dashboard/Uploader";
import TeamSettings from "./containers/Settings/Team";
import ItemDetails from "./containers/ItemDetails";
import Analytics from "./containers/Analytics";
import Wishlist from "./containers/Wishlist/Wishlist";
import WishItemDetail from "./containers/Wishlist/WishItemDetail";
import Paywall from "./containers/Onboard/Paywall";
import PaymentSuccess from "./containers/Onboard/PaymentSuccess";
import Billing from './containers/Settings/Billing';

export default ({ childProps }) =>
  <Switch>
    {/* UnAuthenticated Routes */}
    {/* <UnAuthenticatedRoute exact path="/" render={() => (<Redirect to="/login" />)} props={childProps}/> */}
    <UnAuthenticatedRoute path="/confirm" exact component={Confirm} props={childProps} />
    <UnAuthenticatedRoute path="/login" exact component={Signup} props={childProps} />
    <UnAuthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
    <UnAuthenticatedRoute path="/sso" exact component={FederatedSignin} props={childProps} />
    <UnAuthenticatedRoute path="/login-sso" exact component={SSO} props={childProps} />
    <UnAuthenticatedRoute path="/confirm-verification" exact component={ConfirmVerification} props={childProps} />
    <UnAuthenticatedRoute path="/not-found" exact component={NotFound} props={childProps} />
    <UnAuthenticatedRoute path="/forgot-password" exact component={Forgot} props={childProps} />
    <UnAuthenticatedRoute path="/password-reset" exact component={PasswordReset} props={childProps} />
    <UnAuthenticatedRoute path='/signup-invited-user' exact component={Signup} props={childProps} />
    <UnAuthenticatedRoute path='/signup-partner-owner' exact component={Signup} props={childProps} />
    <UnAuthenticatedRoute path='/removed-site' exact component={RemovedSite} props={childProps} />

    {/* AuthenticatedRoute Routes */}
    <AuthenticatedRoute path="/" exact component={Dashboard} props={childProps} />
    <AuthenticatedRoute path="/onboarding" exact component={Onboard} props={childProps} />
    <AuthenticatedRoute path="/onboarding/survey" exact component={OnboardSurvey} props={childProps} />
    <AuthenticatedRoute path="/onboarding/infographics" exact component={OnboardInfoGraphics} props={childProps} />
    <AuthenticatedRoute path="/onboarding/checklist" exact component={OnboardChecklist} props={childProps} />
    {/* <AuthenticatedRoute path="/onboarding" exact component={Onboard} props={childProps} /> */}
    <AuthenticatedRoute path="/onbboarding-checklist" exact component={OnboardChecklist} props={childProps} />
    <AuthenticatedRoute path="/dashboard" exact component={Dashboard} props={childProps} />
    <AuthenticatedRoute path="/settings" exact component={Settings} props={childProps} />
    <AuthenticatedRoute path="/team-settings" exact component={TeamSettings} props={childProps} />
    <AuthenticatedRoute path="/team-settings/:type" exact component={TeamSettings} props={childProps} />
    <AuthenticatedRoute path="/upload" exact component={Uploader} props={childProps} />
    <AuthenticatedRoute path="/add-import" exact component={Uploader} props={childProps} />
    <AuthenticatedRoute path="/item/detail/:itemId" exact component={ItemDetails} props={childProps} />
    <AuthenticatedRoute path="/collections/detail/:collectionId" exact component={Dashboard} props={childProps} />
    <AuthenticatedRoute path="/collections/detail/:collectionId/edit" exact component={Dashboard} props={childProps} />
    <AuthenticatedRoute path="/analytics" exact component={Analytics} props={childProps} />
    <AuthenticatedRoute path="/wishlist" exact component={Wishlist} props={childProps} />
    <AuthenticatedRoute path="/wish/detail/:wishId" exact component={WishItemDetail} props={childProps} />
    <AuthenticatedRoute path='/paywall' exact component={Paywall} props={childProps} />
    <AuthenticatedRoute path="/billing" exact component={Billing} props={childProps} />
    <AuthenticatedRoute path="/billing/payment-success" exact component={PaymentSuccess} props={childProps} />
    <AuthenticatedRoute path='/removed-site' exact component={RemovedSite} props={childProps} />
    { /* Finally, catch all unmatched routes */ }

    <Route path="/bye" exact render={(props) => <ByePage {...props} isAuthenticated={childProps.isAuthenticated} />} props={childProps} />
    <Route component={NotFound} props={childProps} />
  </Switch>;
